import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import AppBar from "@mui/material/AppBar";

import { Typography } from "@mui/material";
import { connect } from "react-redux";
import { Toolbar } from "@mui/material";

import { Tab, Tabs } from "@mui/material";
import { TabPanel, a11yProps } from "./../common/components/TabPanel";
import PlacementOversight from "./components/placement/PlacementOversight";
import VacanciesOversight from "./components/vacancies/VacanciesOversight";
import TransferOversight from "./components/transfer/TransferOversight";
import MaternityOversight from "./components/maternity/MaternityOversight";
import ScholarshipOversight from "./components/scholarship/ScholarshipOversight";
import SalariesOversight from "./components/salaries/SalariesOversight";
import { useRequiredAuth } from "../common/guard/requiredAuth";

const Oversight = (props) => {
  const location = useLocation();
  const history = useHistory();
  const { hasPermissions } = useRequiredAuth();

  const tabNames = [
    "placements",
    "vacancies",
    "transfers",
    "maternity",
    "scholarship",
    "salaries",
  ];

  const tabPermissions = [
    "OVERSIGHT_PLACEMENTS",
    "OVERSIGHT_VACANCIES",
    "OVERSIGHT_TRANSFERS",
    "OVERSIGHT_MATERNITY_LEAVE",
    "OVERSIGHT_SCHOLARSHIP",
    "OVERSIGHT_SALARIES",
  ];

  const allowedTabs = tabNames.filter((_, index) =>
    hasPermissions([tabPermissions[index]]),
  );

  const visibleTabIndexes = tabNames
    .map((_, index) => (hasPermissions([tabPermissions[index]]) ? index : -1))
    .filter((index) => index !== -1);

  useEffect(() => {
    document.title = "TMIS | Data Insights";

    const queryParams = new URLSearchParams(location.search);
    const tab = queryParams.get("tab");
    const tabIndex = tabNames.indexOf(tab);

    if (tabIndex !== -1 && hasPermissions([tabPermissions[tabIndex]])) {
      const visibleIndex = visibleTabIndexes.indexOf(tabIndex);
      setValue(visibleIndex !== -1 ? visibleIndex : 0);
    } else {
      setValue(0);
    }
  }, [location.search]);

  const { user, loading, systemSettingPositions } = props;

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);

    const actualTabIndex = visibleTabIndexes[newValue];
    const tabName = tabNames[actualTabIndex];

    const queryParams = new URLSearchParams(location.search);
    queryParams.set("tab", tabName);
    history.push({ search: queryParams.toString() });
  };

  return (
    <div className="px-4 pt-2">
      <div className="border rounded">
        <AppBar position="static" elevation={0} className="app-bar w-100">
          <Toolbar
            style={{
              minHeight: "0px",
              borderBottom: "3px solid #e9ecef",
            }}
            className=" my-0 py-1 bg-light"
          >
            <Typography
              variant="p"
              noWrap
              component="div"
              className="d-flex  align-items-center text-uppercase text-primary font-weight-bold"
            >
              <span className="text-dark">Data Insights</span>
              <span className="material-icons" style={{ color: "#cecece" }}>
                chevron_right
              </span>

              <Tabs
                variant="scrollable"
                scrollButtons="auto"
                value={value}
                onChange={handleChange}
              >
                {hasPermissions(["OVERSIGHT_PLACEMENTS"]) && (
                  <Tab label="Placements" {...a11yProps(0)} />
                )}
                {hasPermissions(["OVERSIGHT_VACANCIES"]) && (
                  <Tab label="Vacancies" {...a11yProps(1)} />
                )}
                {hasPermissions(["OVERSIGHT_TRANSFERS"]) && (
                  <Tab label="Transfers" {...a11yProps(2)} />
                )}
                {hasPermissions(["OVERSIGHT_MATERNITY_LEAVE"]) && (
                  <Tab label="Maternity" {...a11yProps(3)} />
                )}
                {hasPermissions(["OVERSIGHT_SCHOLARSHIP"]) && (
                  <Tab label="Scholarship" {...a11yProps(4)} />
                )}
                {hasPermissions(["OVERSIGHT_SALARIES"]) && (
                  <Tab label="Salaries" {...a11yProps(5)} />
                )}
              </Tabs>
            </Typography>
          </Toolbar>
        </AppBar>

        {hasPermissions(["OVERSIGHT_PLACEMENTS"]) && (
          <TabPanel value={value} index={visibleTabIndexes.indexOf(0)}>
            <PlacementOversight />
          </TabPanel>
        )}
        {hasPermissions(["OVERSIGHT_VACANCIES"]) && (
          <TabPanel value={value} index={visibleTabIndexes.indexOf(1)}>
            <VacanciesOversight />
          </TabPanel>
        )}
        {hasPermissions(["OVERSIGHT_TRANSFERS"]) && (
          <TabPanel value={value} index={visibleTabIndexes.indexOf(2)}>
            <TransferOversight />
          </TabPanel>
        )}
        {hasPermissions(["OVERSIGHT_MATERNITY_LEAVE"]) && (
          <TabPanel value={value} index={visibleTabIndexes.indexOf(3)}>
            <MaternityOversight />
          </TabPanel>
        )}
        {hasPermissions(["OVERSIGHT_SCHOLARSHIP"]) && (
          <TabPanel value={value} index={visibleTabIndexes.indexOf(4)}>
            <ScholarshipOversight />
          </TabPanel>
        )}
        {hasPermissions(["OVERSIGHT_SALARIES"]) && (
          <TabPanel value={value} index={visibleTabIndexes.indexOf(5)}>
            <SalariesOversight />
          </TabPanel>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ user, loading, systemSettingPositions }) => {
  return { user, loading, systemSettingPositions };
};

export default connect(mapStateToProps, {})(Oversight);
